import React from "react";
import PropTypes from "prop-types";

import Heading from "core/Heading";
import colors from "core/colors";
import LicenseRadio from "core/LicenseRadio";
import {
    OrderPreviewContainer,
    OrderPreviewContent,
    OrderPreviewDisplay,
    Thumbnail,
    Title
} from "./styles";
import { PHOTO_DETAIL } from "data/links";

const PhotosOrderPreview = ({
    className,
    licenseSchemas,
    title,
    thumbnail,
    slugWithId
}) => (
    <OrderPreviewContainer className={className}>
        <Heading
            type="h2"
            size="xs"
            bottomSpacing="lg"
            headingColor={colors.secondary.orca}
        >
            Order Item
        </Heading>

        <OrderPreviewContent
            className={className}
            alignItems="center"
            justifyContent="space-between"
        >
            <OrderPreviewDisplay>
                <a href={PHOTO_DETAIL.replace(":photoSlugWithId", slugWithId)}>
                    {!!thumbnail && <Thumbnail src={thumbnail} alt={title} />}
                    <Title>
                        <span>{title}</span>
                    </Title>
                </a>
            </OrderPreviewDisplay>
            <div role="radiogroup" aria-labelledby="licensing-options-group">
                {licenseSchemas.map(schema => (
                    <LicenseRadio
                        key={schema.backendKey}
                        type="photo"
                        schema={schema}
                    />
                ))}
            </div>
        </OrderPreviewContent>
    </OrderPreviewContainer>
);

PhotosOrderPreview.propTypes = {
    className: PropTypes.string,
    licenseSchemas: PropTypes.arrayOf(PropTypes.object).isRequired,
    title: PropTypes.string.isRequired,
    thumbnail: PropTypes.string.isRequired,
    slugWithId: PropTypes.string.isRequired
};

export default PhotosOrderPreview;
